"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FacebookSignInButton = _interopRequireDefault(require("./FacebookSignInButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _FacebookSignInButton.default;
exports.default = _default;